;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.filters')
    .filter('cardConcern', CardConcernFilter)

  CardConcernFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function CardConcernFilter (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return function (input) {
      switch (input) {
        case 'product':
          return 'Produit'
        case 'invoice':
          return 'Facture'
        case 'quote':
          return 'Devis'
        case 'balance':
          return 'Balance'
        case 'creditnote':
          return 'Avoir'
        case 'deposit':
          return 'Acompte'
      }
      return input
    }
  }
})(window.angular, window._)
